module.exports = __webpack_public_path__ + "img/not-found.99cd2804.svg";